import c from "./index254.js";
import { resolveComponent as n, createElementBlock as i, openBlock as o, createBlock as t, createCommentVNode as s, createElementVNode as _, toDisplayString as u } from "vue";
import f from "./index231.js";
const h = ["data-component"], k = { class: "ml-8 font-bold text-text-l" };
function v(e, d, b, g, y, C) {
  const r = n("ms-add"), l = n("ms-add-filled"), m = n("ms-remove"), a = n("ms-remove-filled");
  return o(), i("button", {
    class: "flex items-center group h-52",
    type: "button",
    "data-component": e.$options.name,
    onClick: d[0] || (d[0] = (...p) => e.onClick && e.onClick(...p))
  }, [
    e.expanded ? s("", !0) : (o(), t(r, {
      key: 0,
      class: "w-24 h-24 group-hover:hidden"
    })),
    e.expanded ? s("", !0) : (o(), t(l, {
      key: 1,
      class: "hidden w-24 h-24 group-hover:block"
    })),
    e.expanded ? (o(), t(m, {
      key: 2,
      class: "w-24 h-24 group-hover:hidden"
    })) : s("", !0),
    e.expanded ? (o(), t(a, {
      key: 3,
      class: "hidden w-24 h-24 group-hover:block"
    })) : s("", !0),
    _("span", k, u(e.label), 1)
  ], 8, h);
}
const B = /* @__PURE__ */ f(c, [["render", v]]);
export {
  B as default
};
